import React from 'react';

import Button from '@atlaskit/button/standard-button';
import DropdownMenu, {
  DropdownItem,
  DropdownItemGroup,
} from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';

import { DropdownItemDeleteTestStepStyled } from './TestStepMenu.styled';

interface TestStepMenuProps {
  onCloneTestStep: any;
  onDeleteTestStep: any;
}

export const TestStepMenu: React.FC<TestStepMenuProps> = ({
  onCloneTestStep,
  onDeleteTestStep,
}: TestStepMenuProps) => {
  return (
    <DropdownMenu
      shouldFlip={false}
      placement='left-start'
      trigger={({ triggerRef, ...props }) => (
        <Button
          {...props}
          iconBefore={
            <MoreIcon
              label='actions'
              primaryColor='var(--ds-icon, var(--ds-fb-icon))'
            />
          }
          ref={triggerRef}
          appearance='link'
          tabIndex={-1}
          testId='soldeveloTestStepMenuTestId'
        />
      )}
    >
      <DropdownItemGroup>
        <DropdownItem key='cloneTestStep' onClick={() => onCloneTestStep()}>
          Clone Test Step
        </DropdownItem>
        <DropdownItem key='deleteTestStep' onClick={() => onDeleteTestStep()}>
          <DropdownItemDeleteTestStepStyled>
            Delete Test Step
          </DropdownItemDeleteTestStepStyled>
        </DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>
  );
};
